import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { fetchContactsApi } from '../../api/contacts-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  contacts: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchContactsListing = createAsyncThunk(
  'contacts/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
    try {
      const paramsObj = {
        ...updatedParamsObject,
      };
      const res = await fetchContactsApi(paramsObj, '');
      if (res?.status) {
        dispatch(setQuickLinks(res?.user_filters));
      }
      return res;
    } catch (error) {
      toast.error(getErrorString(error));
    }
  },
);

const ContactsSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    setContactsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setContactsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchContactsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchContactsListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.contacts = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchContactsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setContactsLoading, setContactsActiveColumn } = ContactsSlice.actions;
export default ContactsSlice.reducer;
